import {action, observable, runInAction} from 'mobx'
import {decorate, inject, injectable} from '@yosmanyga/di'
import {CredentialManager} from "@yosmanyga/base";
import {
  AuthenticationFrontendWithEmailAbstractApi,
  AuthenticationFrontendWithEmailExpiredCodeApiException
} from '../../data'

class AuthenticationFrontendWithEmailCompleteController {
    @observable accessor email: string | undefined
    @observable accessor code!: string
    @observable accessor error!: string
    @observable accessor loading: boolean
    @observable accessor completing: boolean

    constructor(
        private authenticationFrontendApi: AuthenticationFrontendWithEmailAbstractApi,
        private credentialsManager: CredentialManager,
    ) {
        this.loading = true
        this.completing = false
    }

    @action load = (
        email?: string
    ) => {
        this.email = email
        this.loading = false
    }

    prepare = (
        code: string
    ) => {
        runInAction(() => {
            this.error = ''
            this.code = code
        })
    }

    complete = async () => {
        runInAction(() => {
            this.error = ''
            this.completing = true
        })

        if (!this.code) {
            runInAction(() => {
                this.error = 'Escribe el código de verificación'
                this.completing = false
            })

            return
        }

        if (!this.email) {
            throw new Error();
        }

        let user, token

        try {
            const data = await this.authenticationFrontendApi.complete(
                this.email,
                this.code
            );

            user = data.user
            token = data.token
        } catch (e) {
            runInAction(() => {
                this.error = e instanceof AuthenticationFrontendWithEmailExpiredCodeApiException
                    ? 'El código de verificación ha expirado. Te hemos enviado un nuevo código de verificación'
                    : 'El código de verificación es incorrecto'
                this.completing = false
            })

            return
        }

        await this.credentialsManager.save({
            user: user,
            token: token
        })

        runInAction(() => {
            this.completing = false
        })
    }
}

decorate(injectable(), AuthenticationFrontendWithEmailCompleteController)
decorate(inject(AuthenticationFrontendWithEmailAbstractApi), AuthenticationFrontendWithEmailCompleteController, 0)
decorate(inject(CredentialManager), AuthenticationFrontendWithEmailCompleteController, 1)

export {
    AuthenticationFrontendWithEmailCompleteController
}
